import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Builders } from "@/components/Builders";
import { Services } from "@/components/Categories";
import { AboutUs } from "@/components/AboutUs";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Enquiry } from "@/components/Enquiry";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { StickyEnquiryBar } from "@/components/StickyEnquiryBar";
import PropertyDetail from "@/pages/PropertyDetail";

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <Builders />
      <Services />
      <AboutUs />
      <WhyChooseUs />
      <CTA />
      <Enquiry />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
        </Routes>
        <StickyEnquiryBar />
      </BrowserRouter>
    </div>
  );
}

export default App;
